/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {

	/**
	 * @interface ThemeProviderAPI
	 * @classdesc API class that defines the user profile info accessible in a dashboard
	 */
	class ThemeProviderAPI {
		/**
		 * Loads the the theme definition for the provided theme name
		 * @param {String} [themeName="carbonGrey10"] - the name of the theme to load
		 * @return {Promise} returns a Promise that resolves to the loaded theme definition or if it fails, resolves to the default theme provider
		 */
		loadThemeDefinition() {}
	}

	return ThemeProviderAPI;
});
